const PaymentOrder = () => {
  return (
    <div className="px-4 py-6 lg:h-[500px] lg:w-[95%] lg:self-start">
      We will use template for 3rd party payment here
    </div>
  );
};

export default PaymentOrder;
